import React from 'react';
import Select from 'react-select';
import { FastField } from 'formik';
import { Form, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import FormFeedback from './FormFeedback';
import { isNumeric, formLabel } from '~/utils/helpers';
import { Tooltip } from '~/components/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

const Selectize = ({ as, sm, name, className, options, label, note, setReplacements, maxLimit, tooltip }) => {
    const labelForm = label || formLabel(name);

    return (
        <>
            {options.length > 0 && (
                <FastField name={name}>
                    {({ field, form, meta }) => {
                        const isValid = !meta.error;
                        const isInvalid = meta.touched && !isValid;

                        return (
                            <Form.Group
                                as={as}
                                sm={sm}
                                className={className}
                            >
                                <Form.Label className="d-flex">
                                    {tooltip ? (
                                        <>
                                            {labelForm}
                                            <Tooltip content={tooltip}>
                                                <FontAwesomeIcon
                                                    icon={faCircleInfo}
                                                    size="xs"
                                                    className="fa-light fa-fw ml-1"
                                                />
                                            </Tooltip>
                                        </>
                                    ) : (
                                        labelForm
                                    )}
                                </Form.Label>
                                <Select
                                    {...field}
                                    closeMenuOnSelect={true}
                                    isClearable={true}
                                    isMulti
                                    isOptionDisabled={() => (maxLimit ? meta.value.length >= maxLimit : false)}
                                    options={options}
                                    getOptionLabel={(option) => option.name ? option.name : option.description}
                                    getOptionValue={(option) => option.id}
                                    onChange={function (selectedVals) {
                                        let newArr = [];

                                        selectedVals.forEach((item) => {
                                            newArr.push(isNumeric(item.id) ? parseInt(item.id) : item.id);
                                        }); // this is to get only value of selected option, instead of a whole json. Ref: https://stackoverflow.com/questions/65186192/how-to-only-send-the-value-of-selected-option-with-react-select-and-react-hook-f

                                        form.setFieldValue(field.name, newArr);

                                        if (setReplacements) {
                                            setReplacements(newArr);
                                        }
                                    }}
                                    value={
                                        field.value?.length > 0
                                            ? options.filter((option) => {
                                                  return field.value.includes(
                                                      isNumeric(option.id) ? parseInt(option.id) : option.id,
                                                  ); //field.value.includes(option.id);
                                              })
                                            : null
                                    } // this is to clear selectize UI on formik reset
                                    inputId={name}
                                />
                                <FormFeedback
                                    isInvalid={isInvalid}
                                    isValid={isValid}
                                    errorMessage={meta.error}
                                />
                                {note && <small className="text-primary">{note}</small>}
                            </Form.Group>
                        );
                    }}
                </FastField>
            )}
        </>
    );
};

Selectize.defaultProps = {
    className: '',
    as: Col,
    label: '',
    note: '',
    setReplacements: null,
    maxLimit: null,
    tooltip: '',
};

Selectize.propTypes = {
    as: PropTypes.elementType,
    sm: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
    className: PropTypes.string,
    label: PropTypes.string,
    options: PropTypes.array.isRequired,
    note: PropTypes.string,
    setReplacements: PropTypes.func,
    maxLimit: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    tooltip: PropTypes.string,
};
export default Selectize;
//ref: https://codesandbox.io/s/react-bootstrap-formik-pb831?from-embed=&file=/src/form-section-1.js:436-570
